import WorkroomProjectInfoComponent from './workroom-project-info.component'
import WorkroomProjectInfoService from './workroom-project-info.service'
import WebsiteUrlModalModule from './website-url-modal'

const WorkroomProjectInfoModule = angular.module('cdbl.workroom-project-info', [
  WebsiteUrlModalModule
])
  .service('WorkroomProjectInfoService', WorkroomProjectInfoService)
  .component('cdblWorkroomProjectInfo', WorkroomProjectInfoComponent)
  .name

export default WorkroomProjectInfoModule
